import UnitBody from "./UnitBody";
import UnitFooter from "./UnitFooter";
import UnitHeader from "./UnitHeader";
import { UnitHeaderEdit } from "./UnitEdit";
import PropTypes from "prop-types";
import { StyledUnit } from "../../styles/StyledUnit";
import { getUnit } from "../../api/unit/unit";
import { useQuery } from "react-query";
import { UnitProvider } from "../../context/unitContext";
import { QueryLoader } from "../Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const emptyData = {
	isLoading: false,
	isError: false,
	error: false,
	data: {},
};

export default function Unit({ id, newUnit, isEditMode, setIsEditMode }) {
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data, refetch } = newUnit ? emptyData : useQuery(["unit-id", id], () => getUnit(axiosPrivate, id));
	if (isLoading) {
		return <QueryLoader />;
	}
	if (isError) {
		return <div>{error}</div>;
	}

	return (
		<UnitProvider value={data}>
			<StyledUnit>
				{newUnit || isEditMode ? (
					<UnitHeaderEdit edit={isEditMode} disableEditingMode={() => setIsEditMode(false)} newUnit={newUnit} refetch={refetch} />
				) : (
					<UnitHeader id={id} onClick={() => setIsEditMode(true)} />
				)}

				{!newUnit && <UnitBody edit={false} newUnit={false} id={id} refetch={refetch} upperUnitId={data?.parent?.id}></UnitBody>}
				{!newUnit ? <UnitFooter /> : null}
			</StyledUnit>
		</UnitProvider>
	);
}

Unit.propTypes = {
	id: PropTypes.string,
	isEditMode: PropTypes.bool,
	setIsEditMode: PropTypes.func,
	newUnit: PropTypes.bool,
};

Unit.defaultProps = {
	newUnit: false,
};
